
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights/[slug]",
      function () {
        return require("private-next-pages/insights/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights/[slug]"])
      });
    }
  